import React from 'react';
export var CSPContext = React.createContext({
    nonce: undefined,
});
export var CSPProvider = function (_a) {
    var nonce = _a.nonce, children = _a.children;
    return React.createElement(CSPContext.Provider, { value: { nonce: nonce } }, children);
};
//# sourceMappingURL=CSPProvider.js.map